import React from 'react';
import './Home.css';

function Home() {
  return (
    <div className="home-container">
      <section className="hero">
        <div className="hero-overlay">
          <h2>Stress-free social media management</h2>
          <p>Create and schedule social media content within minutes, seamlessly collaborate with your team or clients, and easily track your success with Threadly all-in-one social media management tool</p>
        </div>
      
      </section>

      <section className="services">
        <div>
        <h2>Social Media Management Services</h2>
        <p>Elevate your brand's online presence with our cutting-edge technology and API integrations</p>
        </div>
      </section>
    </div>
  );
}

export default Home;